import SvgCircleEmpty from 'assets/secure-financing/circle-empty.inline.svg';
import SvgCircleFull from 'assets/secure-financing/circle-full.inline.svg';
import SvgCircleHalf from 'assets/secure-financing/circle-half.inline.svg';
import TooltipCode from 'components/material-ui/TooltipCode';
import { ENUM_FIN_FOR_COMP_LEGEND } from 'components/pages/financing-for-companies/base/enumsFinForComp';
import { cssHalfBlue, cssHalfRed } from 'components/pages/financing-for-companies/items/LegendBox';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';

export default function MarkLegendItem({ value }) {
	const { t } = useTranslation();

	switch (value) {
		case ENUM_FIN_FOR_COMP_LEGEND.NOT_EXISTS: return (
			<TooltipCode Content={t('pageFinancingForCompany.legend.1')}>
				<SvgCircleEmpty stroke="#24BCFD" />
			</TooltipCode>
		);
		case ENUM_FIN_FOR_COMP_LEGEND.LOT_OF_TIME: return (
			<TooltipCode Content={t('pageFinancingForCompany.legend.2')}>
				<SvgCircleHalf css={[ cssHalfBlue ]} />
			</TooltipCode>
		);
		case ENUM_FIN_FOR_COMP_LEGEND.LOT_OF_TIME_FOR_MANY: return (
			<TooltipCode Content={t('pageFinancingForCompany.legend.3')}>
				<SvgCircleFull fill='#24BCFD' />
			</TooltipCode>
		);
		case ENUM_FIN_FOR_COMP_LEGEND.NONE_OR_NOT_EXISTS: return (
			<TooltipCode Content={t('pageFinancingForCompany.legend.4')}>
				<SvgCircleFull fill='#0A9E50' />
			</TooltipCode>
		);
		case ENUM_FIN_FOR_COMP_LEGEND.OFTEN_EXISTS: return (
			<TooltipCode Content={t('pageFinancingForCompany.legend.5')}>
				<SvgCircleHalf css={[ cssHalfRed ]} />
			</TooltipCode>
		);
		case ENUM_FIN_FOR_COMP_LEGEND.ALWAYS_EXISTS: return (
			<TooltipCode Content={t('pageFinancingForCompany.legend.6')}>
				<SvgCircleFull fill='#E91616' />
			</TooltipCode>
		);
		default:
			return null;
	}
}
